(function () {
  'use strict';
  angular
    .module('rosterStatusReportRadarChart')
    .controller('rosterStatusReportRadarChartCtrl', rosterStatusReportRadarChartCtrl);

  function rosterStatusReportRadarChartCtrl(CommonMasterData, rosterStatusReportRadarChartService, MessageService, $compile, $scope, $timeout, StorageServices, TabService, applicationConstants) {
    var vm = this;
    vm.ctrlName = 'rosterStatusReportRadarChartCtrl';
    vm.model = {
      checked: false,
      initialLabels:[],
      labels:[],
      labelsCheckboxStatus: {},
      result_table_data: {"Flight Coverage": [], "Target Hours Coverage": [], "Gender Coverage": [], "Standby Coverage": [], "Language Coverage": []},
      result_table_col_names:[],
      required_labels_for_radar_plot:["Total Flight Coverage %", "Total Night Coverage %",
        "Average assigned Hours to Female", "Average assigned Hours to Male",
        "Gender Ratio (50-50) %","Total SBY Coverage %"],
      previous_chart_obj:null
    };

    var hotSettings = [];

    $timeout(function () {
      vm.submitSearch();
    });

    vm.checkBoxClicked = function (label, labelVal) {
      vm.model.labelsCheckboxStatus[label] = labelVal;

      const colors = ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)'
        ,'rgba(60, 179, 113, 1)','rgba(238, 130, 238,1)', 'rgba(255, 165, 0, 1)', 'rgba(106, 90, 205, 1)'];
      const labels = [];
      const datasets = [];
      let min_scale = 1000000;
      let max_scale = 0;

      rosterStatusReportRadarChartService.searchRosterStatusReportRadarChart(StorageServices.getTabData('rosterStatusReportRadarChart').rosterStatusReportRadarChartParams,
        function (response) {
          var count = 0;
          for (var i in response.rosterScoreList) {

            const json_response = JSON.parse(response.rosterScoreList[i].record);

            if (labels.length === 0) {
              for (var checkboxLabel in vm.model.labelsCheckboxStatus) {
                if (vm.model.labelsCheckboxStatus[checkboxLabel] === true){
                  labels.push(checkboxLabel);
                }
              }
            }
            vm.model.labels = labels;

            const data = {}
            data['label'] = response.rosterScoreList[i].scoreName;
            data["backgroundColor"] = 'rgba(255, 255, 255, 0)';
            data["borderColor"] = colors[count++];
            data['data'] = [];
            for (var j in json_response) {
              if (vm.model.required_labels_for_radar_plot.includes(j) || j.includes("Language")) {
                if (vm.model.labelsCheckboxStatus[j] === true){
                  let display_val = json_response[j].display;
                  if (!display_val){
                    display_val = 0;
                  }
                  if (parseInt(display_val)<min_scale){
                    min_scale = parseInt(display_val);
                  }
                  if (parseInt(display_val)>max_scale){
                    max_scale = parseInt(display_val);
                  }
                  data['data'].push(display_val);
                }
              }
            }
            datasets.push(data);
          }
          max_scale = Math.ceil(max_scale/5)*5 + 10;
          min_scale = Math.ceil(min_scale/5)*5 - 15;
          if (min_scale < 0){
            min_scale = 0
          }
          var options = {
            legend: {
              position: 'bottom',
              labels: {
                padding: 50
              }
            },
            scale: {
              angleLines: {
                display: true
              },
              ticks: {
                suggestedMin: min_scale,
                suggestedMax: max_scale
              }
            },
            elements: {
              line: {
                borderWidth: 3,
                borderColor: 'rgba(0, 0, 0, 0)',
                backgroundColor: 'rgba(0, 0, 0, 0)'
              }
            }
          };

          var data = {
            labels: labels,
            datasets: datasets
          };

          vm.model.previous_chart_obj.destroy();

          var ctx = document.getElementById('myChart');

          var hotSettings = new Chart(ctx, {
            type: 'radar',
            data: data,
            options: options
          });

          vm.model.previous_chart_obj = hotSettings;

          return hotSettings;
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };

    vm.submitSearch = function (params) {
      hotSettings = vm.hotSettings();
    };

    vm.hotSettings = function () {
      const colors = ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)'
        ,'rgba(60, 179, 113, 1)','rgba(238, 130, 238,1)', 'rgba(255, 165, 0, 1)', 'rgba(106, 90, 205, 1)'];
      const labels = [];
      const datasets = [];
      let min_scale = 1000000;
      let max_scale = 0;

      rosterStatusReportRadarChartService.searchRosterStatusReportRadarChart(StorageServices.getTabData('rosterStatusReportRadarChart').rosterStatusReportRadarChartParams,
        function (response) {
          var count = 0;
          for (var i in response.rosterScoreList) {
            const scoreName = response.rosterScoreList[i].scoreName;
            if (scoreName === "BEST_GRID_SCORE" || scoreName === "NON_BEST_GRID_SCORE_1" ||
              scoreName === "NON_BEST_GRID_SCORE_2" || scoreName === "NON_BEST_GRID_SCORE_3"){
              const json_response = JSON.parse(response.rosterScoreList[i].record);
              if (labels.length === 0) {
                for (var k in json_response) {
                  if (vm.model.required_labels_for_radar_plot.includes(k) || k.includes("Language")) {
                    if (k.includes("Language")) {
                      vm.model.labelsCheckboxStatus[k] = false;
                    }else{
                      labels.push(k);
                      vm.model.initialLabels.push(k);
                      vm.model.labelsCheckboxStatus[k] = true;
                    }

                  }
                }
                vm.model.labels = labels;
              }

              const data = {};
              data['label'] = response.rosterScoreList[i].scoreName;
              data["backgroundColor"] = 'rgba(255, 255, 255, 0)';
              data["borderColor"] = colors[count++];
              data['data'] = [];
              for (var j in json_response) {
                if (vm.model.required_labels_for_radar_plot.includes(j)) {
                  let display_val = json_response[j].display;
                  if (!display_val){
                    display_val = 0;
                  }
                  if (parseInt(display_val)<min_scale){
                    min_scale = parseInt(display_val);
                  }
                  if (parseInt(display_val)>max_scale){
                    max_scale = parseInt(display_val);
                  }
                  data['data'].push(display_val);
                }
              }
              datasets.push(data);
            }
          }
          max_scale = Math.ceil(max_scale/5)*5 + 10;
          min_scale = Math.ceil(min_scale/5)*5 - 15;
          if (min_scale < 0){
            min_scale = 0
          }
          var options = {
            legend: {
              position: 'bottom',
              labels: {
                padding: 50
              }
            },
            scale: {
              angleLines: {
                display: true
              },
              ticks: {
                suggestedMin: min_scale,
                suggestedMax: max_scale
              }
            },
            elements: {
              line: {
                borderWidth: 3,
                borderColor: 'rgba(0, 0, 0, 0)',
                backgroundColor: 'rgba(0, 0, 0, 0)'
              }
            }
          };

          // labels.unshift(labels.pop())
          // datasets.unshift(datasets.pop())

          var data = {
            labels: labels,
            datasets: datasets
          };

          var ctx = document.getElementById('myChart');

          var hotSettings = new Chart(ctx, {
            type: 'radar',
            data: data,
            options: options
          });

          vm.model.previous_chart_obj = hotSettings;

          var response_obj_list = [];
          vm.model.result_table_col_names.push(" ");
          for(var i in response.rosterScoreList){
            let scoreName = response.rosterScoreList[i].scoreName;
            if (scoreName === "BEST_GRID_SCORE" || scoreName === "NON_BEST_GRID_SCORE_1" ||
              scoreName === "NON_BEST_GRID_SCORE_2" || scoreName === "NON_BEST_GRID_SCORE_3") {
              response_obj_list.push(JSON.parse(response.rosterScoreList[i].record));
              if (scoreName === "BEST_GRID_SCORE"){
                scoreName = "GRID_1";
              }else if (scoreName === "NON_BEST_GRID_SCORE_1"){
                scoreName = "GRID_2";
              }else if (scoreName === "NON_BEST_GRID_SCORE_2"){
                scoreName = "GRID_3";
              }else if (scoreName === "NON_BEST_GRID_SCORE_3"){
                scoreName = "GRID_4";
              }

              vm.model.result_table_col_names.push(scoreName);
            }
          }
          for(var j in response_obj_list[0]){
            var row_data = [];
            row_data.push(j);
            for(var k in response_obj_list){
              let display_val = response_obj_list[k][j].display;
              if (!display_val){
                display_val = 0;
              }
              row_data.push(display_val);
            }
            if ((row_data[0].toLowerCase()).includes("language")){
              vm.model.result_table_data["Language Coverage"].push(row_data);
            }else if ((row_data[0].toLowerCase()).includes("standby") || (row_data[0].toLowerCase()).includes("sby")){
              vm.model.result_table_data["Standby Coverage"].push(row_data);
            }else if ((row_data[0].toLowerCase()).includes("hours")){
              vm.model.result_table_data["Target Hours Coverage"].push(row_data);
            }else if ((row_data[0].toLowerCase()).includes("male") || (row_data[0].toLowerCase()).includes("female") || (row_data[0].toLowerCase()).includes("gender")){
              vm.model.result_table_data["Gender Coverage"].push(row_data);
            }else{
              vm.model.result_table_data["Flight Coverage"].push(row_data);
            }
          }
          vm.model.result_table_data["Flight Coverage"].sort();

          // Swapping the columns

          let temp = vm.model.result_table_data["Flight Coverage"][0];
          vm.model.result_table_data["Flight Coverage"][0] = vm.model.result_table_data["Flight Coverage"][6];
          vm.model.result_table_data["Flight Coverage"][6] = temp;

          temp = vm.model.result_table_data["Flight Coverage"][7];
          vm.model.result_table_data["Flight Coverage"][7] = vm.model.result_table_data["Flight Coverage"][8];
          vm.model.result_table_data["Flight Coverage"][8] = temp;


          temp = vm.model.result_table_data["Flight Coverage"][7];
          vm.model.result_table_data["Flight Coverage"][7] = vm.model.result_table_data["Flight Coverage"][1];
          vm.model.result_table_data["Flight Coverage"][1] = temp;

          temp = vm.model.result_table_data["Flight Coverage"][2];
          vm.model.result_table_data["Flight Coverage"][2] = vm.model.result_table_data["Flight Coverage"][5];
          vm.model.result_table_data["Flight Coverage"][5] = temp;

          vm.model.result_table_data["Language Coverage"].sort();
          // ordering according to the displayOrder property
          var firstObj = Object.keys(response_obj_list[0])[0];
          if("displayOrder" in response_obj_list[0][firstObj]) {
            var ordered_row_names = [];
            var ordered_table_data = [];
            for (let m = 1; m < vm.model.result_table_data.length + 1; m++) {
              for (var n in response_obj_list[0]) {
                if (parseInt(response_obj_list[0][n].displayOrder) === m) {
                  ordered_row_names.push(n);
                  break;
                }
              }
            }
            for (var name in ordered_row_names) {
              for (var row in vm.model.result_table_data) {
                if (vm.model.result_table_data[row][0] === ordered_row_names[name]) {
                  ordered_table_data.push(vm.model.result_table_data[row]);
                  break;
                }
              }
            }
            vm.model.result_table_data = ordered_table_data;
          }

          return hotSettings;
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );

    };

  }
}());
